// extracted by mini-css-extract-plugin
export default {"l":"_2ee6eae7c9"};